<template>
  <v-app style="height: 100%; max-width: 450px"
    :class="{on_desktop: $vuetify.breakpoint.smAndUp}"
  >
    <div class="d-flex justify-center" style="background-color: #004056;">
      <v-img max-height="76px" max-width="85%" src="@/assets/logo_white_transparent_background.png" />
    </div>
    <v-main class="grey lighten-3" style="height: calc(100% - 76px);">
      <router-view />
    </v-main>
  </v-app>
</template>
<script>


export default {
  name: 'LoggedOutLayout',
}
</script>
